(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.announcement-bar__messages');
      if (!this.track) return;

      /*
       * The direct children of the track, not the [data-announcement-message]
       * elements themselves: the blocks tag wraps each block in its own
       * <div class="shopify-block">, and it is that wrapper the CSS
       * stacks and fades. Marking the <p> inside it left every wrapper without
       * [data-active], so on mobile the [data-ready] rule hid the first message
       * and the base rule hid the rest - an empty bar. Reading the children
       * keeps working whether or not Shopify wraps the block.
       */
      this.messages = Array.from(this.track.children).filter(function(el) {
        return el.matches('[data-announcement-message]') || el.querySelector('[data-announcement-message]');
      });
      if (this.messages.length < 2) return;

      this.index = 0;
      // Nothing auto-rotates for someone who has asked for less motion.
      this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Desktop rotates one message fewer, so re-plan when the layout flips.
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.onBreakpoint = () => this.sync();
      this.mobile.addEventListener('change', this.onBreakpoint);

      // Someone reading a message should not have it swapped out from under them.
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.resume());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.resume());

      this.sync();
    }

    disconnectedCallback() {
      this.stop();
      this.mobile?.removeEventListener('change', this.onBreakpoint);
    }

    /*
     * Mobile rotates every message; desktop rotates all but the last, which the
     * CSS pins to the right. With nothing to rotate, hand back to the CSS.
     */
    sync() {
      this.stop();
      this.rotating = this.mobile.matches ? this.messages : this.messages.slice(0, -1);
      if (this.rotating.length < 2) {
        this.track.removeAttribute('data-ready');
        this.messages.forEach(function(el) { el.removeAttribute('data-active'); });
        return;
      }
      // Taking over from the CSS no-JS fallback.
      this.track.setAttribute('data-ready', '');
      this.show(this.index % this.rotating.length);
      this.resume();
    }

    show(next) {
      var active = this.rotating[next];
      this.messages.forEach(function(el) {
        if (el === active) el.setAttribute('data-active', '');
        else el.removeAttribute('data-active');
      });
      this.index = next;
    }

    start() {
      this.stop();
      var interval = parseInt(this.dataset.interval, 10) || 5000;
      this.timer = setInterval(() => {
        this.show((this.index + 1) % this.rotating.length);
      }, interval);
    }

    resume() {
      if (this.rotating.length > 1 && !this.paused) this.start();
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.overlay      = this.querySelector('.cart-drawer__overlay');
      this.closeButton  = this.querySelector('.cart-drawer__close');
      this.toggleButton = document.getElementById(this.dataset.toggle);
      this.onKeydown    = this.onKeydown.bind(this);

      this.toggleButton?.addEventListener('click', function(event) {
        event.preventDefault();
        this.open ? this.close() : this.openDrawer();
      }.bind(this));
      this.closeButton?.addEventListener('click', function() { this.close(); }.bind(this));
      this.overlay?.addEventListener('click', function() { this.close(); }.bind(this));

      this.addEventListener('click', function(event) {
        var stepper = event.target.closest('[data-cart-qty]');
        if (stepper) {
          event.preventDefault();
          var input = stepper.parentElement.querySelector('.cart-drawer__qty-input');
          var next = parseInt(input.value, 10) + parseInt(stepper.dataset.cartQty, 10);
          this.changeLine(this.lineOf(stepper), Math.max(next, 0), stepper);
          return;
        }

        var remove = event.target.closest('[data-cart-remove]');
        if (remove) {
          event.preventDefault();
          this.changeLine(this.lineOf(remove), 0, remove);
          return;
        }

        var button = event.target.closest('[data-cart-upsell]');
        if (!button || button.getAttribute('aria-busy') === 'true') return;

        var variantId = button.getAttribute('data-variant-id');
        if (!variantId) return;

        button.setAttribute('aria-busy', 'true');
        fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function() { document.dispatchEvent(new CustomEvent('cart:item-added')); })
          .catch(function() { window.location.href = (window.Shopify?.routes?.root || '/') + 'cart'; })
          .finally(function() { button.removeAttribute('aria-busy'); });
      }.bind(this));

      // A typed quantity, committed on blur or Enter.
      this.addEventListener('change', function(event) {
        var input = event.target.closest('.cart-drawer__qty-input');
        if (!input) return;
        var quantity = parseInt(input.value, 10);
        this.changeLine(this.lineOf(input), isNaN(quantity) ? 1 : Math.max(quantity, 0), input);
      }.bind(this));

      this.addEventListener('keydown', function(event) {
        if (event.key !== 'Enter') return;
        var input = event.target.closest('.cart-drawer__qty-input');
        if (!input) return;
        event.preventDefault();
        input.blur();
      });

      document.addEventListener('cart:item-added', function() {
        this.refresh().then(function() {
          if (this.dataset.openOnAdd === 'true') this.openDrawer();
        }.bind(this));
      }.bind(this));

      // Quantity changes made on the cart page: resync, but never pop open.
      document.addEventListener('cart:updated', function() {
        this.refresh();
      }.bind(this));
    }

    get open() {
      return this.hasAttribute('open');
    }

    openDrawer() {
      this.setAttribute('open', '');
      this.removeAttribute('inert');
      this.setAttribute('aria-hidden', 'false');
      this.toggleButton?.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', this.onKeydown);
      this.closeButton?.focus();
    }

    close() {
      this.removeAttribute('open');
      this.setAttribute('inert', '');
      this.setAttribute('aria-hidden', 'true');
      this.toggleButton?.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', this.onKeydown);
      this.toggleButton?.focus();
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.close();
    }

    lineOf(element) {
      return parseInt(element.closest('[data-cart-line]').dataset.cartLine, 10);
    }

    /*
     * Every quantity change goes through here - the steppers, a typed value,
     * and Remove, which is just quantity 0. The remove link's href points at
     * /cart/change, which redirects to the cart page: fine without JavaScript,
     * wrong here, since emptying the cart should leave the shopper in the
     * drawer looking at its empty state rather than on a reloaded page.
     *
     * Lines are addressed by index rather than by variant id, so two lines of
     * the same variant with different properties cannot be confused.
     *
     * `sections` rides along on the same request, so the new markup comes back
     * with the change instead of needing a second round trip. The cart page is
     * asked for too when one is on screen - the drawer is present on every
     * template, and a change here would otherwise leave that page stale.
     */
    changeLine(line, quantity, target) {
      if (this.getAttribute('aria-busy') === 'true') return;
      this.setAttribute('aria-busy', 'true');

      var page = document.querySelector('cart-page');
      var ids = ['cart-drawer'];
      if (page && page.dataset.sectionId) ids.push(page.dataset.sectionId);

      // Re-rendering the list destroys the control that was clicked, so note
      // what it was: a shopper tapping "+" repeatedly should not lose focus
      // after the first tap.
      var focus = this.focusHint(target, line);

      fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: ids.join(',') })
      })
        .then(function(response) {
          if (!response.ok) throw new Error();
          return response.json();
        })
        .then(function(cart) {
          var sections = cart.sections || {};
          this.render(sections['cart-drawer']);
          if (page && sections[page.dataset.sectionId]) {
            page.replaceContents(sections[page.dataset.sectionId]);
          }
          this.updateHeaderCount();
          this.restoreFocus(focus);
        }.bind(this))
        .catch(function() {
          if (target && target.href) window.location.href = target.href;
          else window.location.reload();
        })
        .finally(function() { this.removeAttribute('aria-busy'); }.bind(this));
    }

    focusHint(target, line) {
      if (!target) return null;
      if (target.classList.contains('cart-drawer__qty-input')) return { line: line, sel: '.cart-drawer__qty-input' };
      if (target.dataset.cartQty) return { line: line, sel: '[data-cart-qty="' + target.dataset.cartQty + '"]' };
      return null;
    }

    restoreFocus(hint) {
      var next = hint && this.querySelector('[data-cart-line="' + hint.line + '"] ' + hint.sel);
      // A disabled control cannot take focus, which is what happens to "-" at
      // a quantity of one.
      if (next && !next.disabled) {
        next.focus();
        return;
      }
      // The row is gone, or its control is now disabled: keep focus inside the
      // dialog rather than letting it fall to <body>.
      if (!document.activeElement || document.activeElement === document.body) {
        this.closeButton?.focus();
      }
    }

    refresh() {
      return fetch((window.Shopify?.routes?.root || '/') + '?sections=cart-drawer')
        .then(function(r) { return r.json(); })
        .then(function(sections) {
          this.render(sections['cart-drawer']);
          this.updateHeaderCount();
        }.bind(this));
    }

    /*
     * Swaps the parts of the panel that depend on the cart. A part missing
     * from the new markup is removed and one that is newly present is
     * appended, which is what turns the item list, totals and shipping bar
     * into the empty-cart message when the last line goes.
     */
    render(markup) {
      if (!markup) return;
      var doc = new DOMParser().parseFromString(markup, 'text/html');

      ['.cart-drawer__shipping', '.cart-drawer__items', '.cart-drawer__upsell', '.cart-drawer__footer', '.cart-drawer__empty'].forEach(function(sel) {
        var next = doc.querySelector(sel);
        var curr = this.querySelector(sel);
        if (next && curr) curr.replaceWith(next);
        else if (next)    this.querySelector('.cart-drawer__panel').appendChild(next);
        else if (curr)    curr.remove();
      }.bind(this));
    }

    updateHeaderCount() {
      fetch((window.Shopify?.routes?.root || '/') + 'cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var toggle = document.getElementById('cart-drawer-toggle');
          if (!toggle) return;
          var sup = toggle.querySelector('sup');
          if (cart.item_count > 0) {
            if (!sup) { sup = document.createElement('sup'); toggle.prepend(sup); }
            sup.textContent = cart.item_count;
          } else if (sup) {
            sup.remove();
          }
        });
    }
  }

  customElements.define('cart-drawer', CartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartPage extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;

      // The plain form post is the no-JS path; hide it now that JS is running.
      var fallback = this.querySelector('[data-cart-update-fallback]');
      if (fallback) fallback.hidden = true;

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
    }

    // Enter inside the quantity field would otherwise submit the form, and its
    // first submit button is "checkout".
    onKeydown(event) {
      if (event.key !== 'Enter') return;
      var input = event.target.closest('.cart-page__qty-input');
      if (!input) return;
      event.preventDefault();
      input.blur();
    }

    onClick(event) {
      var stepper = event.target.closest('[data-cart-qty]');
      if (stepper) {
        event.preventDefault();
        var input = stepper.parentElement.querySelector('.cart-page__qty-input');
        var next = parseInt(input.value, 10) + parseInt(stepper.dataset.cartQty, 10);
        this.change(this.lineOf(stepper), Math.max(next, 0));
        return;
      }

      var remove = event.target.closest('[data-cart-remove]');
      if (remove) {
        event.preventDefault();
        this.change(this.lineOf(remove), 0);
      }
    }

    onChange(event) {
      var input = event.target.closest('.cart-page__qty-input');
      if (!input) return;
      var quantity = parseInt(input.value, 10);
      this.change(this.lineOf(input), isNaN(quantity) ? 1 : Math.max(quantity, 0));
    }

    lineOf(element) {
      return element.closest('[data-cart-line]').dataset.cartLine;
    }

    change(line, quantity) {
      if (this.getAttribute('aria-busy') === 'true') return;
      this.setAttribute('aria-busy', 'true');

      fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: this.sectionId })
      })
        .then(function(response) {
          if (!response.ok) throw new Error();
          return response.json();
        })
        .then(function(cart) {
          var markup = cart.sections && cart.sections[this.sectionId];
          if (markup) this.replaceContents(markup);
          // Keeps the drawer and the header count in step without opening it.
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }.bind(this))
        .catch(function() { window.location.reload(); })
        .finally(function() { this.removeAttribute('aria-busy'); }.bind(this));
    }

    replaceContents(markup) {
      var doc = new DOMParser().parseFromString(markup, 'text/html');
      var next = doc.querySelector('cart-page');
      if (next) this.innerHTML = next.innerHTML;
      var fallback = this.querySelector('[data-cart-update-fallback]');
      if (fallback) fallback.hidden = true;
    }
  }

  customElements.define('cart-page', CartPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["city-list"] && !Shopify.designMode) return;
  try {
    
  class CityIndex extends HTMLElement {
    connectedCallback() {
      this.search = this.querySelector('.city-list__search');
      this.input = this.querySelector('.city-list__search-input');
      this.empty = this.querySelector('.city-list__empty');
      this.groups = Array.from(this.querySelectorAll('.city-list__group'));
      if (!this.search || !this.input || !this.groups.length) return;

      /*
       * Folded once here rather than on every keystroke: NFD splits a letter
       * from its accent, and dropping the combining marks is what lets
       * "malmo" find Malmö and "goteborg" find Göteborg. Swedish readers do
       * not reliably reach for å, ä and ö when typing a search.
       */
      this.cities = Array.from(this.querySelectorAll('.city-list__city')).map((el) => ({
        el: el,
        text: this.fold(el.querySelector('.city-list__city-name').textContent),
        stores: Array.from(el.querySelectorAll('.city-list__store')).map((store) => ({
          el: store,
          text: this.fold(store.textContent)
        }))
      }));

      // Only now is the field worth showing - see the comment on it.
      this.search.hidden = false;
      this.input.addEventListener('input', () => this.filter());

      // Escape clears the field, as it would in any search input.
      this.input.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || this.input.value === '') return;
        this.input.value = '';
        this.filter();
      });
    }

    fold(value) {
      return value.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    filter() {
      var term = this.fold(this.input.value);
      var matches = 0;

      this.cities.forEach(function (city) {
        /*
         * Matching the city keeps all of its shops - someone searching
         * "malmo" wants every Malmö shop, not the ones that happen to repeat
         * the city in their name. Matching only a shop narrows the city to
         * the shops that matched.
         */
        var cityHit = term === '' || city.text.indexOf(term) !== -1;
        var storeHit = false;

        city.stores.forEach(function (store) {
          var hit = cityHit || store.text.indexOf(term) !== -1;
          store.el.hidden = !hit;
          if (hit && !cityHit) storeHit = true;
        });

        var show = cityHit || storeHit;
        city.el.hidden = !show;
        if (show) matches += 1;
      });

      // A letter with nothing left under it goes too, so the index does not
      // keep a row of headings over empty space.
      this.groups.forEach(function (group) {
        group.hidden = !group.querySelector('.city-list__city:not([hidden])');
      });

      if (this.empty) this.empty.hidden = matches !== 0;
    }
  }

  customElements.define('city-index', CityIndex);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-cookie-settings]').forEach(function(button) {
      button.addEventListener('click', function() {
        // Exposed by Shopify's consent banner once it has loaded.
        var banner = window.Shopify && window.Shopify.privacyBanner;
        if (banner && typeof banner.showPreferences === 'function') {
          banner.showPreferences();
        }
      });
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var header = document.querySelector('[data-transparent-header]');
    if (!header) return;

    /*
     * Solid only while scrolling back up: scrolling down keeps the bar
     * transparent over the page, scrolling up brings the white surface in,
     * and the top of the page always clears it. THRESHOLD keeps mobile
     * browsers that report a non-zero scrollY at rest from tripping it;
     * DELTA ignores the few-pixel jitter of a resting finger or trackpad.
     */
    var THRESHOLD = 10;
    var DELTA = 6;
    var lastY = window.scrollY;
    var ticking = false;

    function sync() {
      var y = window.scrollY;
      if (y <= THRESHOLD) {
        header.classList.remove('is-scrolled');
      } else if (y < lastY - DELTA) {
        header.classList.add('is-scrolled');
      } else if (y > lastY + DELTA) {
        header.classList.remove('is-scrolled');
      }
      if (Math.abs(y - lastY) > DELTA || y <= THRESHOLD) lastY = y;
      ticking = false;
    }

    sync();
    window.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(sync);
    }, { passive: true });
  })();

  class RegionDrawer extends HTMLElement {
    connectedCallback() {
      this.overlay = this.querySelector('.region-drawer__overlay');
      this.closeButton = this.querySelector('.region-drawer__close');
      this.select = this.querySelector('.region-drawer__select');
      this.onKeydown = this.onKeydown.bind(this);

      /*
       * Delegated from the document rather than bound to one id: the footer is
       * a separate section, so its trigger does not exist yet when this runs,
       * and the theme editor can re-render either section at any point.
       */
      this.triggers = Array.from(document.querySelectorAll('[data-region-drawer-open]'));
      document.addEventListener('click', (event) => {
        var trigger = event.target.closest('[data-region-drawer-open]');
        if (!trigger) return;
        event.preventDefault();
        if (this.triggers.indexOf(trigger) === -1) this.triggers.push(trigger);
        this.lastTrigger = trigger;
        this.open ? this.close() : this.openDrawer();
      });

      this.closeButton?.addEventListener('click', () => this.close());
      this.overlay?.addEventListener('click', () => this.close());
    }

    get open() {
      return this.hasAttribute('open');
    }

    // Every trigger carries the state, not just the one that was pressed.
    flag(state) {
      this.triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', state);
      });
    }

    openDrawer() {
      this.setAttribute('open', '');
      this.removeAttribute('inert');
      this.setAttribute('aria-hidden', 'false');
      this.flag('true');
      document.addEventListener('keydown', this.onKeydown);
      // The list is what the drawer is for, so it takes the focus.
      this.select?.focus();
    }

    close() {
      this.removeAttribute('open');
      this.setAttribute('inert', '');
      this.setAttribute('aria-hidden', 'true');
      this.flag('false');
      document.removeEventListener('keydown', this.onKeydown);
      // Back to whichever trigger opened it, not always the header's.
      this.lastTrigger?.focus();
      // Drop an unconfirmed choice, so reopening starts from the live country
      // rather than from wherever the list was left.
      this.select?.form?.reset();
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.close();
    }
  }

  customElements.define('region-drawer', RegionDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["intent-popup"] && !Shopify.designMode) return;
  try {
    
  class IntentPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;

      this.key = this.dataset.storageKey;
      this.showOnce = this.dataset.showOnce === 'true';
      this.isEditor = typeof Shopify !== 'undefined' && Shopify.designMode;

      // In the editor the merchant needs to see it while the section is
      // selected, and never while they are working on something else.
      if (this.isEditor) {
        this.bindEditor();
      } else if (!this.showOnce || !this.answered()) {
        window.setTimeout(this.open.bind(this), parseInt(this.dataset.delay, 10) || 0);
      }

      // A choice answers the question; the link then navigates as normal.
      this.querySelectorAll('[data-intent-choice]').forEach(
        function (choice) {
          choice.addEventListener('click', this.remember.bind(this));
        }.bind(this)
      );

      // Covers Esc and any other native close, so the popup does not come
      // straight back on the next page.
      this.dialog.addEventListener('close', this.remember.bind(this));
    }

    open() {
      if (!this.dialog.open) this.dialog.showModal();
    }

    // Storage throws in some privacy modes; the popup working is worth more
    // than the memory of it, so a failure here is not fatal.
    answered() {
      try {
        return Boolean(window.localStorage.getItem(this.key));
      } catch (error) {
        return false;
      }
    }

    remember() {
      if (this.isEditor || !this.showOnce) return;
      try {
        window.localStorage.setItem(this.key, '1');
      } catch (error) {
        /* ignore */
      }
    }

    bindEditor() {
      var id = this.dataset.sectionId;

      document.addEventListener(
        'shopify:section:select',
        function (event) {
          if (event.detail.sectionId === id) this.open();
        }.bind(this)
      );

      document.addEventListener(
        'shopify:section:deselect',
        function (event) {
          if (event.detail.sectionId === id && this.dialog.open) this.dialog.close();
        }.bind(this)
      );
    }
  }

  customElements.define('intent-popup', IntentPopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-popup"] && !Shopify.designMode) return;
  try {
    
  class OfferPopup extends HTMLElement {
    connectedCallback() {
      var delay     = parseInt(this.dataset.delay) || 0;
      var showOnce  = this.dataset.showOnce === 'true';
      var key       = this.dataset.storageKey;
      var isEditor  = typeof Shopify !== 'undefined' && Shopify.designMode;

      if (showOnce && !isEditor && localStorage.getItem(key)) return;

      setTimeout(function() {
        this.removeAttribute('hidden');
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            this.classList.add('is-visible');
          }.bind(this));
        }.bind(this));
      }.bind(this), isEditor ? 0 : delay);

      this.querySelector('.offer-popup__close').addEventListener('click', function() {
        this.classList.remove('is-visible');
        if (showOnce) localStorage.setItem(key, '1');
        setTimeout(function() { this.setAttribute('hidden', ''); }.bind(this), 300);
      }.bind(this));
    }
  }

  customElements.define('offer-popup', OfferPopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  class ProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.product-carousel__track');
      this.prevBtn = this.querySelector('.product-carousel__btn--prev');
      this.nextBtn = this.querySelector('.product-carousel__btn--next');

      if (!this.track) return;

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function() { this.step(-1); }.bind(this));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function() { this.step(1); }.bind(this));
      }

      this.track.addEventListener('scroll', function() { this.updateNav(); }.bind(this), { passive: true });
      this.updateNav();
    }

    step(dir) {
      var card = this.track.querySelector('.product-card');
      if (!card) return;
      var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: 'smooth' });
    }

    updateNav() {
      if (!this.prevBtn || !this.nextBtn) return;
      var sl = Math.round(this.track.scrollLeft);
      var max = this.track.scrollWidth - this.track.offsetWidth;
      this.prevBtn.disabled = sl <= 0;
      this.nextBtn.disabled = sl >= max;
    }
  }

  customElements.define('product-carousel', ProductCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /* Quantity stepper: the -/+ buttons drive the number input. */
  document.querySelectorAll('[data-quantity]').forEach(function (wrapper) {
    var input = wrapper.querySelector('input[type="number"]');
    if (!input) return;

    var min = parseInt(input.getAttribute('min'), 10) || 1;

    function syncDisabled() {
      var value = parseInt(input.value, 10) || min;
      wrapper.querySelectorAll('[data-quantity-step]').forEach(function (button) {
        if (parseInt(button.dataset.quantityStep, 10) < 0) {
          button.disabled = value <= min;
        }
      });
    }

    wrapper.querySelectorAll('[data-quantity-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        var step = parseInt(button.dataset.quantityStep, 10) || 0;
        var next = (parseInt(input.value, 10) || min) + step;
        if (next < min) next = min;
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        syncDisabled();
      });
    });

    // Typing straight into the field has to keep the buttons in step too.
    input.addEventListener('input', syncDisabled);
    syncDisabled();
  });

  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.product-gallery__track');
      this.slides = Array.from(this.querySelectorAll('.product-gallery__slide'));
      this.thumbs = Array.from(this.querySelectorAll('.product-gallery__thumb'));
      // The lightbox zooms stills; video slides are navigated past, not opened.
      this.imageSlides = this.slides.filter(function(slide) {
        return slide.dataset.mediaType !== 'video';
      });
      this.lightboxIndex = 0;

      this.setupVideos();

      this.thumbs.forEach(function(thumb, i) {
        thumb.addEventListener('click', function() { this.scrollToIndex(i); }.bind(this));
      }.bind(this));

      if (this.track && this.slides.length > 1) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              var index = this.slides.indexOf(entry.target);
              this.setActiveThumb(index);
            }
          }.bind(this));
        }.bind(this), { root: this.track, threshold: 0.5 });

        this.slides.forEach(function(slide) { observer.observe(slide); });
      }

      var variantSelect = document.getElementById('variant-select');
      if (variantSelect) {
        variantSelect.addEventListener('change', function() {
          var imageId = variantSelect.options[variantSelect.selectedIndex].dataset.imageId;
          if (!imageId) return;
          var index = this.slides.findIndex(function(s) { return s.dataset.imageId === imageId; });
          if (index >= 0) this.scrollToIndex(index);
        }.bind(this));
      }

      if (this.imageSlides.length > 0) {
        this.lightbox = this.buildLightbox();
        document.body.appendChild(this.lightbox);

        this.imageSlides.forEach(function(slide, i) {
          slide.addEventListener('click', function() { this.openLightbox(i); }.bind(this));
        }.bind(this));
      }
    }

    /*
     * Hydrogen autoplayed every video on mount. Here a video only plays while
     * its slide is actually on screen, which looks the same to a viewer but
     * does not stream a carousel slide nobody has scrolled to. iOS needs both
     * `muted` and `playsinline` set as properties for inline autoplay.
     */
    setupVideos() {
      var videos = Array.from(this.querySelectorAll('.product-gallery__slide--video video'));
      if (!videos.length) return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      videos.forEach(function(video) {
        video.muted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.loop = true;
      });

      // No autoplay for reduced motion, so the controls come back: without
      // them the video could not be started at all.
      if (reduceMotion) {
        videos.forEach(function(video) { video.controls = true; });
        return;
      }

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            // A rejected play() (a browser blocking autoplay) leaves the
            // poster; the controls are shown so it can still be started.
            var attempt = video.play();
            if (attempt && attempt.catch) attempt.catch(function() { video.controls = true; });
          } else if (!video.paused) {
            video.pause();
          }
        });
      }, { threshold: 0.5 });

      videos.forEach(function(video) { observer.observe(video); });
    }

    buildLightbox() {
      var dialog = document.createElement('dialog');
      dialog.className = 'gallery-lightbox';
      dialog.setAttribute('scroll-lock', '');
      dialog.innerHTML =
        '<button type="button" class="gallery-lightbox__close" aria-label="Close">×</button>' +
        '<button type="button" class="gallery-lightbox__prev" aria-label="Previous image">‹</button>' +
        '<div class="gallery-lightbox__media"></div>' +
        '<button type="button" class="gallery-lightbox__next" aria-label="Next image">›</button>';

      this.lbMedia = dialog.querySelector('.gallery-lightbox__media');
      this.lbPrev = dialog.querySelector('.gallery-lightbox__prev');
      this.lbNext = dialog.querySelector('.gallery-lightbox__next');
      this.wasDragging = false;

      dialog.addEventListener('click', function(e) {
        if (e.target === dialog) dialog.close();
      });

      dialog.querySelector('.gallery-lightbox__close').addEventListener('click', function() {
        dialog.close();
      });

      this.lbPrev.addEventListener('click', function() { this.lightboxStep(-1); }.bind(this));
      this.lbNext.addEventListener('click', function() { this.lightboxStep(1); }.bind(this));

      dialog.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') this.lightboxStep(-1);
        if (e.key === 'ArrowRight') this.lightboxStep(1);
      }.bind(this));

      // Touch swipe for slide navigation — skip when image is zoomed (user is panning)
      var touchX = 0, touchY = 0;
      dialog.addEventListener('touchstart', function(e) {
        touchX = e.touches[0].clientX;
        touchY = e.touches[0].clientY;
      }, { passive: true });
      dialog.addEventListener('touchend', function(e) {
        if (this.lbMedia.classList.contains('is-zoomed')) return;
        var dx = e.changedTouches[0].clientX - touchX;
        var dy = e.changedTouches[0].clientY - touchY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          this.lightboxStep(dx < 0 ? 1 : -1);
        }
      }.bind(this));

      // Mouse drag to pan when zoomed
      var isDragging = false, startX, startY, scrollX, scrollY;
      this.lbMedia.addEventListener('mousedown', function(e) {
        if (!this.lbMedia.classList.contains('is-zoomed')) return;
        isDragging = true;
        this.wasDragging = false;
        startX = e.clientX; startY = e.clientY;
        scrollX = this.lbMedia.scrollLeft; scrollY = this.lbMedia.scrollTop;
        e.preventDefault();
      }.bind(this));
      document.addEventListener('mousemove', function(e) {
        if (!isDragging) return;
        if (Math.abs(e.clientX - startX) > 3 || Math.abs(e.clientY - startY) > 3) {
          this.wasDragging = true;
        }
        this.lbMedia.scrollLeft = scrollX - (e.clientX - startX);
        this.lbMedia.scrollTop  = scrollY - (e.clientY - startY);
      }.bind(this));
      document.addEventListener('mouseup', function() { isDragging = false; });

      return dialog;
    }

    openLightbox(index) {
      this.lightboxIndex = index;
      this.renderLightboxSlide(index);
      this.lightbox.showModal();
    }

    renderLightboxSlide(index) {
      this.lbMedia.classList.remove('is-zoomed');

      var slide = this.imageSlides[index];
      var img = slide.querySelector('img');

      var display = new Image();
      display.className = 'gallery-lightbox__img';
      if (img) { display.src = img.src; display.alt = img.alt; }
      this.lbMedia.innerHTML = '';
      this.lbMedia.appendChild(display);

      // Click image → toggle zoom, centered on the click point
      display.addEventListener('click', function(e) {
        if (this.wasDragging) { this.wasDragging = false; return; }
        e.stopPropagation();
        var zooming = this.lbMedia.classList.toggle('is-zoomed');
        if (zooming) {
          var rx = (e.clientX - display.getBoundingClientRect().left) / display.offsetWidth;
          var ry = (e.clientY - display.getBoundingClientRect().top)  / display.offsetHeight;
          requestAnimationFrame(function() {
            this.lbMedia.scrollLeft = rx * this.lbMedia.scrollWidth  - this.lbMedia.offsetWidth  / 2;
            this.lbMedia.scrollTop  = ry * this.lbMedia.scrollHeight - this.lbMedia.offsetHeight / 2;
          }.bind(this));
        }
      }.bind(this));

      // Load full-resolution image after opening
      var zoomSrc = slide.dataset.zoomSrc;
      if (zoomSrc && img && zoomSrc !== img.src) {
        var full = new Image();
        var capturedIndex = index;
        full.onload = function() {
          if (this.lightboxIndex === capturedIndex) display.src = zoomSrc;
        }.bind(this);
        full.src = zoomSrc;
      }

      this.lbPrev.hidden = index === 0;
      this.lbNext.hidden = index === this.imageSlides.length - 1;
    }

    lightboxStep(dir) {
      var next = this.lightboxIndex + dir;
      if (next < 0 || next >= this.imageSlides.length) return;
      this.lightboxIndex = next;
      this.renderLightboxSlide(next);
    }

    scrollToIndex(index) {
      if (!this.track) return;
      this.track.scrollTo({ left: index * this.track.offsetWidth, behavior: 'smooth' });
      this.setActiveThumb(index);
    }

    setActiveThumb(index) {
      this.thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      if (this.thumbs[index]) {
        this.thumbs[index].classList.add('is-active');
        this.thumbs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }
  }

  customElements.define('product-gallery', ProductGallery);

  (function() {
    var form = document.querySelector('.product-form');
    if (!form) return;

    var submitBtn = form.querySelector('.product-form__submit');
    var submitLabel = form.querySelector('.product-form__submit-label');
    var originalValue = submitLabel ? submitLabel.textContent : '';

    // The button carries the variant's price, so it has to follow the select.
    var variantSelect = form.querySelector('#variant-select');
    if (variantSelect && submitBtn) {
      variantSelect.addEventListener('change', function() {
        var option = variantSelect.options[variantSelect.selectedIndex];
        var label = option && option.dataset.label ? option.dataset.label.trim() : '';
        if (!label) return;
        originalValue = label;
        if (submitLabel) submitLabel.textContent = label;
        submitBtn.disabled = option.disabled;
      });
    }

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      if (submitBtn) {
        // aria-busy both drives the spinner in CSS and announces the wait.
        submitBtn.setAttribute('aria-busy', 'true');
        submitBtn.disabled = true;
        if (submitLabel) submitLabel.textContent = submitBtn.dataset.adding || originalValue;
      }

      fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function(r) {
          if (!r.ok) throw new Error();
          return r.json();
        })
        .then(function() {
          document.dispatchEvent(new CustomEvent('cart:item-added'));
        })
        .catch(function() {
          form.submit();
        })
        .finally(function() {
          if (submitBtn) {
            submitBtn.removeAttribute('aria-busy');
            submitBtn.disabled = false;
            if (submitLabel) submitLabel.textContent = originalValue;
          }
        });
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-popup"]) return;
  try {
    
  class SearchPopup extends HTMLElement {
    connectedCallback() {
      this.closeButton = this.querySelector('.search-popup__close');
      this.input = this.querySelector('.search-popup__input');
      this.toggleButton = document.getElementById(this.dataset.toggle);
      this.onKeydown = this.onKeydown.bind(this);
      this.onResize = this.onResize.bind(this);

      this.toggleButton?.addEventListener('click', (event) => {
        // The toggle is a link to the search page; the popup replaces that
        // navigation only once this script has taken it over.
        event.preventDefault();
        this.open ? this.close() : this.openPopup();
      });
      this.closeButton?.addEventListener('click', () => this.close());
    }

    /*
     * The panel starts at the header's bottom edge so the bar stays visible and
     * usable while the search is open. It is measured rather than assumed: the
     * announcement bar sits above the header only at the top of the page, so
     * the header's offset changes with the scroll position.
     */
    positionBelowHeader() {
      var header = document.querySelector('.header-section');
      var bottom = header ? header.getBoundingClientRect().bottom : 0;
      this.style.setProperty('--search-panel-top', Math.max(bottom, 0) + 'px');

      /*
       * Freezing the page removes its scrollbar, and the header stays on show
       * over the panel - so without this it would jump sideways by the
       * scrollbar's width as the search opens. Measured while the scrollbar is
       * still there, which is why this runs before the open attribute is set.
       */
      var doc = document.documentElement;
      var gap = window.innerWidth - doc.clientWidth;
      if (gap > 0) doc.style.setProperty('--search-scrollbar-gap', gap + 'px');
    }

    onResize() {
      this.positionBelowHeader();
    }

    get open() {
      return this.hasAttribute('open');
    }

    openPopup() {
      // Before the panel is shown, so it never paints at the wrong offset.
      this.positionBelowHeader();
      this.setAttribute('open', '');
      this.removeAttribute('inert');
      this.setAttribute('aria-hidden', 'false');
      this.toggleButton?.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', this.onKeydown);
      window.addEventListener('resize', this.onResize);

      /*
       * Reading a layout property forces the pending style change to be
       * applied. Until [open] actually lands the panel is `visibility: hidden`,
       * and a hidden element cannot take focus - so focusing in the same task
       * without this silently does nothing and the field opens unfocused.
       *
       * Deliberately not deferred to requestAnimationFrame, which would fix the
       * same problem: that breaks the user-gesture chain, and iOS only raises
       * the keyboard for a focus that happens inside the click.
       */
      void this.offsetHeight;

      // The field, not the close button: the search exists so the shopper can
      // start typing straight away. `preventScroll` because the page behind is
      // frozen and must not be jumped. Selecting the carried-over term on a
      // search page means the next keystroke replaces it.
      this.input?.focus({ preventScroll: true });
      this.input?.select();
    }

    close() {
      this.removeAttribute('open');
      this.setAttribute('inert', '');
      this.setAttribute('aria-hidden', 'true');
      this.toggleButton?.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('resize', this.onResize);
      document.documentElement.style.removeProperty('--search-scrollbar-gap');
      this.toggleButton?.focus();
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      // predictive-search.js handles Escape on the input first to dismiss its
      // result list; only the second press should close the popup itself.
      if (event.defaultPrevented) return;
      this.close();
    }
  }

  customElements.define('search-popup', SearchPopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["side-menu"]) return;
  try {
    
  class SideMenuDrawer extends HTMLElement {
    connectedCallback() {
      this.overlay = this.querySelector('.side-menu__overlay');
      this.closeButton = this.querySelector('.side-menu__close');
      this.titleEl = this.querySelector('.side-menu__title');
      this.toggleButton = document.getElementById(this.dataset.toggle);
      this.onKeydown = this.onKeydown.bind(this);
      this.lastTrigger = null;

      this.toggleButton?.addEventListener('click', () => {
        this.open ? this.close() : this.openMenu();
      });
      this.closeButton?.addEventListener('click', () => this.close());
      this.overlay?.addEventListener('click', () => this.close());

      this.addEventListener('click', (event) => {
        var opener = event.target.closest('[data-panel-open]');
        if (opener && this.contains(opener)) {
          this.openPanel(opener);
          return;
        }

        var back = event.target.closest('[data-panel-back]');
        if (back && this.contains(back)) this.closePanel();
      });
    }

    get open() {
      return this.hasAttribute('open');
    }

    openMenu() {
      this.setAttribute('open', '');
      this.removeAttribute('inert');
      this.setAttribute('aria-hidden', 'false');
      this.toggleButton?.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', this.onKeydown);
      this.closeButton?.focus();
    }

    close() {
      this.removeAttribute('open');
      this.setAttribute('inert', '');
      this.setAttribute('aria-hidden', 'true');
      this.toggleButton?.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', this.onKeydown);
      this.toggleButton?.focus();
      // Reset to the root view so the drawer reopens where it started.
      this.closePanel(true);
    }

    openPanel(trigger) {
      var id = trigger.getAttribute('data-panel-open');
      var view = this.querySelector('[data-panel-view="' + id + '"]');
      if (!view) return;

      this.lastTrigger = trigger;
      this.setAttribute('data-panel', id);
      trigger.setAttribute('aria-expanded', 'true');
      view.hidden = false;
      if (this.titleEl) this.titleEl.textContent = trigger.getAttribute('data-panel-heading') || '';
      view.querySelector('[data-panel-back]')?.focus();
    }

    closePanel(skipFocus) {
      this.removeAttribute('data-panel');
      this.querySelectorAll('[data-panel-view]').forEach(function(view) { view.hidden = true; });
      this.querySelectorAll('[data-panel-open]').forEach(function(trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
      if (this.titleEl) this.titleEl.textContent = this.dataset.rootHeading || '';
      if (!skipFocus) this.lastTrigger?.focus();
      this.lastTrigger = null;
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      // Escape steps back out of a sub-panel before closing the drawer.
      if (this.hasAttribute('data-panel')) this.closePanel();
      else this.close();
    }
  }

  customElements.define('side-menu-drawer', SideMenuDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-reels"] && !Shopify.designMode) return;
  try {
    
  class UgcReels extends HTMLElement {
    connectedCallback() {
      this.key = 'ugc-reels-dismissed';
      // How long a closed widget stays closed. Keep in step with the inline script above.
      this.dismissFor = 24 * 60 * 60 * 1000;
      this.isEditor = Boolean(window.Shopify && window.Shopify.designMode);
      this.reels = Array.from(this.querySelectorAll('[data-reel]'));
      this.toggle = this.querySelector('[data-reels-toggle]');
      this.seek = this.querySelector('[data-reels-seek]');
      this.scrubbing = false;
      this.muteButton = this.querySelector('[data-reels-mute]');
      // Muted until the visitor turns sound on with the mute button; expanding
      // or shrinking the card leaves it as it is.
      this.muted = true;
      this.index = 0;

      if (!this.isEditor && this.dismissed()) {
        this.hidden = true;
        return;
      }

      this.setMuteUi();

      // iOS only autoplays video that is muted and inline from the markup on,
      // whatever the player tag emitted.
      this.querySelectorAll('video').forEach(function (video) {
        video.muted = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
      });

      this.fadeIn();

      this.toggle.addEventListener('click', this.toggleExpanded.bind(this));
      this.seek.addEventListener('input', this.onSeek.bind(this));
      this.muteButton.addEventListener('click', this.toggleMute.bind(this));
      this.seek.addEventListener(
        'pointerdown',
        function () {
          this.scrubbing = true;
        }.bind(this)
      );
      document.addEventListener(
        'pointerup',
        function () {
          if (!this.scrubbing) return;
          this.scrubbing = false;
            }.bind(this)
      );
      this.querySelector('[data-reels-close]').addEventListener('click', this.dismiss.bind(this));
      document.addEventListener('keydown', this.onKey.bind(this));

      // Autoplay is motion the visitor did not ask for; with reduced motion the
      // poster is shown and a tap on the card starts the video.
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.reels.forEach(
        function (reel, i) {
          var video = reel.querySelector('video');
          if (!video) return;
          video.addEventListener('waiting', this.setLoading.bind(this, i, true));
          ['loadeddata', 'canplay', 'playing', 'pause', 'error'].forEach(
            function (name) {
              video.addEventListener(name, this.setLoading.bind(this, i, false));
            }.bind(this)
          );
          video.addEventListener('timeupdate', this.onTime.bind(this, i));
          video.addEventListener('loadedmetadata', this.onTime.bind(this, i));
          video.addEventListener(
            'ended',
            function () {
              if (i === this.index) this.show(this.index + 1);
            }.bind(this)
          );
        }.bind(this)
      );

      // Pause while the tab is hidden so a backgrounded page does not keep decoding.
      document.addEventListener(
        'visibilitychange',
        function () {
          var video = this.current();
          if (!video) return;
          if (document.hidden) video.pause();
          else if (!this.reduceMotion || this.hasAttribute('data-expanded')) this.play(video);
        }.bind(this)
      );

      if (this.isEditor) {
        document.addEventListener(
          'shopify:block:select',
          function (event) {
            var i = this.reels.indexOf(event.target);
            if (i > -1) this.show(i);
          }.bind(this)
        );
      }

      // Every page is a fresh load, so pick up where the last page left off
      // instead of starting the first reel over.
      var saved = this.restore();
      if (saved) {
        this.muted = saved.muted !== false;
        this.setMuteUi();
        if (saved.expanded) this.setExpanded(true);
      }
      this.show(saved ? saved.index : 0, saved ? saved.time : 0);

      window.addEventListener('pagehide', this.save.bind(this));

      // Two frames on, the restored state has painted; animate from here on.
      window.requestAnimationFrame(
        function () {
          window.requestAnimationFrame(this.removeAttribute.bind(this, 'data-restoring'));
        }.bind(this)
      );
    }

    setProgress(value) {
      this.seek.value = String(value);
      this.style.setProperty('--seek', String(value / 10));
    }

    // Holds each video back until it has a frame, then lets it fade in. The
    // timer is the way out for reels that never load until they play.
    fadeIn() {
      this.setAttribute('data-fade', '');

      this.reels.forEach(function (reel) {
        var video = reel.querySelector('video');
        var ready = function () {
          reel.setAttribute('data-ready', '');
        };

        if (!video || video.readyState >= 2) ready();
        else video.addEventListener('loadeddata', ready, { once: true });
        window.setTimeout(ready, 1500);
      });
    }

    // The spinner stands in for the active video while it has nothing to show.
    setLoading(i, loading) {
      if (i !== this.index) return;
      var video = this.current();
      this.toggleAttribute('data-loading', Boolean(loading && video && video.readyState < 3));
    }

    // The bar follows the playing reel; a drag in progress is not fought over.
    onTime(i) {
      this.save(true);
      var video = this.current();
      if (i !== this.index || !video || this.scrubbing || !isFinite(video.duration) || !video.duration) return;
      this.setProgress((video.currentTime / video.duration) * 1000);
    }

    onSeek() {
      var video = this.current();
      if (!video || !isFinite(video.duration)) return;
      video.currentTime = (this.seek.value / 1000) * video.duration;
      this.setProgress(Number(this.seek.value));
    }

    current() {
      var reel = this.reels[this.index];
      return reel ? reel.querySelector('video') : null;
    }

    show(i, start) {
      var previous = this.current();
      if (previous) previous.pause();

      if (!this.reels.length) return;
      this.index = (i + this.reels.length) % this.reels.length;
      this.reels.forEach(
        function (reel, n) {
          reel.toggleAttribute('data-active', n === this.index);
        }.bind(this)
      );

      var video = this.current();
      if (!video) return;

      video.currentTime = start || 0;
      this.setProgress(0);
      video.muted = this.muted;
      // A single reel loops; several play through one after another.
      video.loop = this.reels.length === 1;
      if (!this.reduceMotion || this.hasAttribute('data-expanded')) this.play(video);
    }

    // A new page has had no tap, so the browser may refuse sound. Fall back to
    // muted rather than not playing, and let the mute button say so. If even
    // muted playback is refused (iOS in Low Power Mode), the first touch
    // anywhere on the page starts it.
    play(video) {
      this.setLoading(this.index, true);
      var promise = video.play();
      if (!promise || !promise.catch) return;

      promise.catch(
        function () {
          if (video.muted) {
            this.playOnTouch();
            return;
          }
          video.muted = true;
          this.muted = true;
          this.setMuteUi();
          var retry = video.play();
          if (retry && retry.catch) retry.catch(this.playOnTouch.bind(this));
        }.bind(this)
      );
    }

    playOnTouch() {
      if (this.waitingForTouch) return;
      this.waitingForTouch = true;
      this.setLoading(this.index, false);

      var events = ['pointerdown', 'touchend', 'keydown'];
      var start = function () {
        this.waitingForTouch = false;
        events.forEach(function (name) {
          document.removeEventListener(name, start, true);
        });
        var video = this.current();
        if (video && !this.hidden) this.play(video);
      }.bind(this);

      events.forEach(function (name) {
        document.addEventListener(name, start, true);
      });
    }

    setExpanded(expanded) {
      this.toggleAttribute('data-expanded', expanded);
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.toggle.setAttribute('aria-label', this.toggle.dataset[expanded ? 'labelCollapse' : 'labelExpand']);
    }

    toggleExpanded() {
      var expanded = !this.hasAttribute('data-expanded');
      var video = this.current();

      this.setExpanded(expanded);

      if (video) {
        video.muted = this.muted;
        this.play(video);
      }
    }

    // The choice holds across reels until the visitor changes it again.
    toggleMute() {
      this.muted = !this.muted;
      var video = this.current();
      if (video) video.muted = this.muted;
      this.setMuteUi();
    }

    setMuteUi() {
      this.muteButton.setAttribute('aria-pressed', String(this.muted));
      this.muteButton.setAttribute('aria-label', this.muteButton.dataset[this.muted ? 'labelUnmute' : 'labelMute']);
      this.toggleAttribute('data-muted', this.muted);
    }

    onKey(event) {
      if (event.key === 'Escape' && this.hasAttribute('data-expanded')) this.toggleExpanded();
    }

    // Position is kept per browser session. Throttled while playing, and always
    // written as the page goes away. Sound is not carried over: the next page
    // has had no tap yet, so it can only start muted.
    save(throttle) {
      if (this.isEditor || this.hidden) return;
      var now = Date.now();
      if (throttle === true && now - (this.savedAt || 0) < 1000) return;
      this.savedAt = now;

      var video = this.current();
      if (!video) return;
      try {
        window.sessionStorage.setItem(
          this.key + '-state',
          JSON.stringify({
            index: this.index,
            time: video.currentTime,
            expanded: this.hasAttribute('data-expanded'),
            muted: this.muted
          })
        );
      } catch (error) {
        /* ignore */
      }
    }

    restore() {
      if (this.isEditor) return null;
      try {
        var state = JSON.parse(window.sessionStorage.getItem(this.key + '-state'));
        if (state && state.index >= 0 && state.index < this.reels.length && state.time >= 0) return state;
      } catch (error) {
        /* ignore */
      }
      return null;
    }

    // Remembered across visits, but only for a while, so the widget comes back.
    dismissed() {
      try {
        var closedAt = Number(window.localStorage.getItem(this.key));
        if (!closedAt) return false;
        if (Date.now() - closedAt < this.dismissFor) return true;
        window.localStorage.removeItem(this.key);
      } catch (error) {
        /* ignore */
      }
      return false;
    }

    dismiss() {
      if (this.hasAttribute('data-expanded')) this.toggleExpanded();
      var video = this.current();
      if (video) video.pause();
      this.hidden = true;
      if (this.isEditor) return;
      try {
        window.localStorage.setItem(this.key, String(Date.now()));
      } catch (error) {
        /* ignore */
      }
    }
  }

  customElements.define('ugc-reels', UgcReels);

  } catch(e) { console.error(e); }
})();
})();
